<template>
  <Grid class="order-invoices-tab" gap="var(--r-space-sp)" align-content="start">
    <Orders />
    <AdditionalOrders :namespace="namespace" />
    <Invoices />
    <AdditionalInvoices :namespace="namespace" />
  </Grid>
</template>

<script>
// Components
import AdditionalOrders from '@/reusable/additional-orders/AdditionalOrders'
import AdditionalInvoices from '@/reusable/additional-invoices/AdditionalInvoices'
import Orders from './components/Orders'
import Invoices from './components/invoices/Invoices'

export default {
  components: {
    AdditionalOrders,
    AdditionalInvoices,
    Orders,
    Invoices
  },

  props: {
    namespace: {
      type: String,
      required: true
    }
  }
}
</script>
